const HEX_VALS = 'abcdefg123456790'
export function shortUid(): string {
  let uid = ''
  while (uid.length < 8) {
    uid += HEX_VALS[Math.floor(Math.random() * HEX_VALS.length)]
  }
  return uid
}
